var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticClass:"mt-0"}),_c('div',[_c('div',{staticClass:"display-4 font-3xl mb-3"},[_c('b-row',{staticClass:"pr-3"},[_c('b-col',[_vm._v(_vm._s(_vm.process.process.name))])],1)],1),(
        _vm.process.process.schedulable_tasks &&
        _vm.process.process.schedulable_tasks.length
      )?_c('b-tabs',{staticClass:"mb-3"},[_vm._l((_vm.process.process.schedulable_tasks),function(collection,index){return [(!collection.parent_id)?[_c('instrument-selector',{key:index,attrs:{"collection":collection,"process":_vm.process.process}})]:_vm._e()]})],2):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }